import { IconPropsDeprecated } from '@umanforge/common';

export const AddressIcon = ( { className, size, onClick }: IconPropsDeprecated ) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 449.73099 510.70001"
      className={ className }
      style={{ height: size, width: size }}
      onClick={ onClick }
    >
      <path d="m 384,192 c 0,87.4 -116.99999,243 -168.29999,307.2 -12.3,15.3 -35.1,15.3 -47.4,0 C 117.00002,435 0,279.4 0,192 0,86 86.00001,0 192.00002,0 298.00002,0 384,86 384,192 Z"/>
      <path
        style={{
          fill: '#ffffff',
          fillOpacity: 1
        }}
        d="m 192,108 c 35.34625,0 63.99997,28.65378 63.99997,64 0,35.34622 -28.65372,64 -63.99997,64 -35.34625,0 -63.99997,-28.65378 -63.99997,-64 0,-35.34622 28.65372,-64 63.99997,-64 z"
      />
      <path
        style={{
          stroke: '#ffffff',
          strokeWidth: 20,
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          strokeDasharray: 'none',
          strokeOpacity: 1,
          paintOrder: 'normal'
        }}
        d="m 459.67851,400.42842 c 0,8.06035 -6.71696,14.37429 -14.32951,14.37429 h -14.32952 l 0.31346,71.73712 c 0,1.20905 -0.0896,2.41811 -0.22389,3.62715 v 7.20954 c 0,9.89632 -8.01558,17.91189 -17.91188,17.91189 h -7.16476 c -0.49258,0 -0.98516,0 -1.47773,-0.0448 -0.62691,0.0448 -1.25383,0.0448 -1.88075,0.0448 h -14.55341 -10.74714 c -9.89631,0 -17.91188,-8.01557 -17.91188,-17.91189 v -10.74713 -28.65903 c 0,-7.92601 -6.4035,-14.3295 -14.32951,-14.3295 h -28.65902 c -7.92601,0 -14.32952,6.40349 -14.32952,14.3295 v 28.65903 10.74713 c 0,9.89632 -8.01557,17.91189 -17.91188,17.91189 H 273.48443 259.1997 c -0.6717,0 -1.34339,-0.0448 -2.01509,-0.0896 -0.53735,0.0448 -1.07472,0.0896 -1.61207,0.0896 h -7.16475 c -9.89632,0 -17.91189,-8.01557 -17.91189,-17.91189 v -50.15329 c 0,-0.40302 0,-0.85081 0.0448,-1.25383 v -31.16669 h -14.3743 c -8.06035,0 -14.32951,-6.26916 -14.32951,-14.37429 0,-4.03018 1.34339,-7.61255 4.47798,-10.74713 L 321.13005,289.5986 c 3.13458,-3.13457 6.71696,-3.58237 9.85153,-3.58237 3.13459,0 6.71697,0.89559 9.40375,3.13458 l 114.36741,100.53048 c 3.58238,3.13458 5.37357,6.71695 4.92577,10.74713 z"
      />
    </svg>
  );
};